import { profileEditComponent } from './profile-edit.component';

export const profileEdit = angular
	.module('components.profile.profileEdit', [])
	.component('profileEdit', profileEditComponent)
	.config(($stateProvider) => {
		'ngInject';

		$stateProvider
			.state('profileEdit', {
			    parent: 'app',
                url: '/profile/:id/edit',
				breadcrumbName: 'edit profile',
				parentState: 'profileDetail',
				component: 'profileEdit',
				resolve: {
					details(ProfileService, $stateParams) {
						'ngInject';	
						return ProfileService.getProfileDetailsById($stateParams.id);
					}
				}
			});
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/components/profile/profile-edit/profile-edit.module.js